import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTableSimple from "commons/ui/datatable/DataTableSimple";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import TemplatesTableFilters from "components/subComponents/TemplatesTableFilters";

import useTemplateList from "hooks/list/useTemplateList";

function ElencoTemplates() {
    const templatesListHook = useTemplateList();

    const { navigateToNewTemplate, alertConfirmHook, dataTableHook } = templatesListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <Paper className={"table-with-filters"}>
                <TemplatesTableFilters templatesListHook={templatesListHook} />

                <DataTableSimple dataTableHook={dataTableHook} />
            </Paper>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewTemplate}>
                        Nuovo Template
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoTemplates;
